import React from "react";

// import { styled } from "@mui/material";

import { SingleOptionPage } from "./SingleOptionPage";
import { Question, QuestionDefinitionDto } from "./questionaire-types";

type ColorPageProps = {
  questionDefinition: QuestionDefinitionDto;
  onNext: (question: Question) => void;
  isSaving: boolean;
  isFrenchLanguage:boolean;
};

export const ColorPage = (props: ColorPageProps) => {
  const { questionDefinition, onNext, isSaving } = props;

  // const BpIcon = styled("span")(({ color }) => ({
  //   borderRadius: "50%",
  //   width: 60,
  //   height: 60,
  //   backgroundColor: color,
  // }));

  // const BpCheckedIcon = styled(BpIcon)({
  //   "&:before": {
  //     display: "block",
  //     width: 60,
  //     height: 60,
  //     backgroundImage: "radial-gradient(#209653,#209653 28%,transparent 32%)",
  //     content: '""',
  //   },
  // });
  return (
    <SingleOptionPage
      questionDefinition={questionDefinition}
      onNext={onNext}     
      isSaving={isSaving}
      isFrenchLanguage={props.isFrenchLanguage}
    />
  );
};
